/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicApiKeyMetadata
 */
export interface PublicApiKeyMetadata {
    /**
     * 
     * @type {string}
     * @memberof PublicApiKeyMetadata
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PublicApiKeyMetadata
     */
    clientName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PublicApiKeyMetadata
     */
    scopes: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof PublicApiKeyMetadata
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PublicApiKeyMetadata
     */
    expiresAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PublicApiKeyMetadata
     */
    revokedAt: Date | null;
}

/**
 * Check if a given object implements the PublicApiKeyMetadata interface.
 */
export function instanceOfPublicApiKeyMetadata(value: object): value is PublicApiKeyMetadata {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('revokedAt' in value) || value['revokedAt'] === undefined) return false;
    return true;
}

export function PublicApiKeyMetadataFromJSON(json: any): PublicApiKeyMetadata {
    return PublicApiKeyMetadataFromJSONTyped(json, false);
}

export function PublicApiKeyMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicApiKeyMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'clientName': json['clientName'],
        'scopes': json['scopes'],
        'createdAt': (new Date(json['createdAt'])),
        'expiresAt': (json['expiresAt'] == null ? null : new Date(json['expiresAt'])),
        'revokedAt': (json['revokedAt'] == null ? null : new Date(json['revokedAt'])),
    };
}

export function PublicApiKeyMetadataToJSON(json: any): PublicApiKeyMetadata {
    return PublicApiKeyMetadataToJSONTyped(json, false);
}

export function PublicApiKeyMetadataToJSONTyped(value?: PublicApiKeyMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'clientName': value['clientName'],
        'scopes': value['scopes'],
        'createdAt': value['createdAt'].toISOString(),
        'expiresAt': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
        'revokedAt': value['revokedAt'] == null ? value['revokedAt'] : value['revokedAt'].toISOString(),
    };
}

